"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colorFoundationTokens = _interopRequireDefault(require("./color-foundation-tokens"));
var _typography = require("../shared/typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// We don't use this ourselves. We provide it for backward compatibility.
// People may have used it to create their own custom theme.
const primitives = {
  ..._colorFoundationTokens.default,
  ..._typography.fontTokens
};
var _default = exports.default = primitives;